module.exports = {
	"naslov": "Nemački izveštaj",
	"tekst": "Po mišljenju komandanta Srbije, a u suprotnosti sa iznetim za Hrvatsku, nemiri se u prvom redu i gotovo isključivo imaju pripisati komunističkom uticaju.",
	"potpis": "Nemački izveštaj od 11. avgusta 1941."
};


//////////////////
// WEBPACK FOOTER
// ./src/hronologija/1941/08-11/podaci.json
// module id = 43
// module chunks = 0